"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var useLogin_1 = require("@hooks/useLogin");
var style = __importStar(require("./Login.module.scss"));
var useClearOnTime_1 = __importDefault(require("@hooks/useClearOnTime"));
var GDDHeader_1 = __importDefault(require("@components/Headers/GDDHeader"));
var authLocalisation_1 = require("./authLocalisation");
var useCurrentLanguage_1 = require("@hooks/useCurrentLanguage");
var auth_1 = require("@services/auth");
var react_redux_1 = require("react-redux");
var modalSlice_1 = require("@store/slices/modalSlice");
var modalSlice_2 = require("@store/slices/modalSlice");
var loaderSlice_1 = require("@store/slices/loaderSlice");
var LoginPage = function () {
    var _a = (0, react_1.useState)(""), email = _a[0], setEmail = _a[1];
    var _b = (0, react_1.useState)(""), password = _b[0], setPassword = _b[1];
    var _c = (0, react_1.useState)(""), submitMessage = _c[0], setSubmitMessage = _c[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var lang = (0, useCurrentLanguage_1.useCurrentLanguage)();
    var t = authLocalisation_1.authTranslator[lang];
    var navigate = (0, react_router_dom_1.useNavigate)();
    (0, useClearOnTime_1.default)({ setText: setSubmitMessage, text: submitMessage });
    var handleLogin = (0, useLogin_1.useLogin)(email, password, setSubmitMessage);
    var handleRegisterRedirect = function () {
        navigate("/register");
    };
    var handlePasswordForgot = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (email.length === 0) {
                        setSubmitMessage(t.loginMessages.emptyEmail);
                        return [2 /*return*/];
                    }
                    dispatch((0, loaderSlice_1.setLoading)(true));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, (0, auth_1.forgotPasswordAPI)(email)];
                case 2:
                    res = _a.sent();
                    if (res.success) {
                        dispatch((0, modalSlice_1.showModal)({ activeModal: modalSlice_2.ActiveModal.Info, text: res.message }));
                        return [2 /*return*/];
                    }
                    setSubmitMessage(res.message);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    setSubmitMessage(error_1);
                    return [3 /*break*/, 5];
                case 4:
                    dispatch((0, loaderSlice_1.setLoading)(false));
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(GDDHeader_1.default, {}), (0, jsx_runtime_1.jsxs)("form", { onSubmit: handleLogin, className: style.login_container, children: [(0, jsx_runtime_1.jsx)("h2", { children: t.loginFormTitle }), (0, jsx_runtime_1.jsxs)("div", { className: style.form_group, children: [(0, jsx_runtime_1.jsxs)("label", { children: [t.email, ":"] }), (0, jsx_runtime_1.jsx)("input", { type: "email", value: email, onChange: function (e) { return setEmail(e.target.value); }, required: true, style: { margin: "10px 0", padding: "8px", width: "100%" } })] }), (0, jsx_runtime_1.jsxs)("div", { className: style.form_group, children: [(0, jsx_runtime_1.jsxs)("label", { children: [t.pass, ":"] }), (0, jsx_runtime_1.jsx)("input", { type: "password", value: password, onChange: function (e) { return setPassword(e.target.value); }, required: true, style: { margin: "10px 0", padding: "8px", width: "100%" } })] }), (0, jsx_runtime_1.jsx)("span", { className: style.forgot_password, children: (0, jsx_runtime_1.jsx)("button", { type: "button", onClick: handlePasswordForgot, children: "Forgot password?" }) }), submitMessage.length > 0 ? ((0, jsx_runtime_1.jsx)("div", { className: "".concat(style.form_group, " ").concat(style.error), children: "*".concat(submitMessage) })) : null, (0, jsx_runtime_1.jsxs)("div", { className: style.button_group, children: [(0, jsx_runtime_1.jsx)("button", { type: "submit", className: style.login_btn, children: t.loginFormTitle }), (0, jsx_runtime_1.jsx)("button", { type: "button", onClick: handleRegisterRedirect, className: style.register_btn, children: t.regFormTitle })] })] })] }));
};
exports.default = LoginPage;
